import React from "react";
import HeroSection from "../components/HeroSection";
import ContactUs from "../components/page-components/contact/ContactSection";
import GlobalContact from "../components/page-components/contact/GlobalContact";
import SocialContact from "../components/page-components/contact/SocialContact";
import { Helmet } from "react-helmet-async";

function Contact() {
  return (
    <>
      <Helmet>
        <title>
          Contact Web X Secure | Website Development, SEO & Digital Marketing
        </title>

        <meta
          name="description"
          content="Connect with our team for website development, SEO, digital marketing, cybersecurity, SaaS development, and business automation solutions designed to accelerate business growth."
        />

        <meta
          name="keywords"
          content="Contact Web X Secure, Website Development Company, SEO Company, Digital Marketing Agency, Cyber Security Services"
        />

        <link rel="canonical" href="https://webxsecure.in/contact" />

        <meta property="og:title" content="Contact Web X Secure" />

        <meta
          property="og:description"
          content="Get in touch with our team for web development, SEO, digital marketing and cybersecurity services."
        />

        <meta property="og:url" content="https://webxsecure.in/contact" />

        <meta property="og:image" content="https://webxsecure.in/logo.png" />

        <meta property="og:type" content="website" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ContactPage",
            name: "Contact Web X Secure",
            url: "https://webxsecure.in/contact",
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://webxsecure.in",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Contact",
                item: "https://webxsecure.in/contact",
              },
            ],
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://webxsecure.in",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Contact",
                item: "https://webxsecure.in/contact",
              },
            ],
          })}
        </script>
      </Helmet>

      <div>
        <HeroSection
          subtitle="Get In Touch"
          title="Web X Secure – Start Your Next Digital Project"
          description="Whether you need a business website, web application, SEO services, digital marketing strategy, or cybersecurity solution, our team is ready to turn your ideas into measurable business results."
        />
        <ContactUs />
        <GlobalContact />
        <SocialContact />
      </div>
    </>
  );
}

export default Contact;
